<template>
  <v-touch
      class="row unloading-info"

      @press="deviationOptions('unloading', unloadedProduct.barcode, { id: unloadedProduct.product.incomingOrderId }, unloadedProduct && unloadedProduct.product ? unloadedProduct.product.id : undefined, unloadedProduct.locationId)"
  >

    <div class="col-7 unloading-info-left">
      <p class="product-number"> {{ unloadedProduct.barcode }}</p>
      <p class="location"><i class="far fa-warehouse-alt"></i> {{ getLocation(unloadedProduct.locationId).name }}</p>
    </div>

    <div class="col-5 unloading-info-right">
      <p><i class="far fa-clock"></i>
        <strong>{{ formatTime(unloadedProduct.endTime) }}</strong></p>
    </div>
  </v-touch>
</template>

<script>
import {mapGetters} from 'vuex'


export default {
  name: 'unloaded-product',
  props: ['unloadedProduct'],
  data() {
    return {
      recentlyAdded: true
    }
  },
  methods: {
    formatTime(time) {
      return moment(time.toDate()).format('HH:mm')
    },
    // async deviationOptions(product) {
    //   await navigator.vibrate(50)
    //   return this.$swal({
    //     customClass: 'options-modal',
    //     title: this.$root.$t('whatDoYouWantToDo'),
    //     html: `<select class="form-control" id="select-action">
    //         <option value="" selected disabled>Select..</option>
    //         <option value="/register-deviation?location=unloading&locationAdditional=${product.barcode}">${this.$root.$t('cargo.registerDeviation.title')}</option></select>`,
    //     showConfirmButton: true,
    //     showCloseButton: true,
    //     preConfirm: function () {
    //       return new Promise(function (resolve) {
    //         resolve(
    //             $('#select-action').val()
    //         )
    //       })
    //     }
    //   }).then(res => {
    //     if(res !== null) {
    //       this.$router.push({path: res.value})
    //     }
    //
    //   })
    // }
  },
  computed: {
    ...mapGetters('locations',   ['getLocation'])
  },
  created() {
    var self = this
    setTimeout(() => {
      self.recentlyAdded = false
    }, 1000)
  }
}
</script>

<style scoped lang="scss">

.unloading-info:first-child {
  background-color: #ffffff;
  margin: auto;
  border-bottom: 1px solid #DCDCDC;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
}

.unloading-info:nth-child(odd) {
  background-color: #ffffff;
  margin: auto;
  border-bottom: 1px solid #DCDCDC;
}

.unloading-info {
  margin: auto;
  background-color: #F0F0F0;
  border-bottom: 1px solid #F0F0F0;
}

.unloading-info-left {

  margin-top: 15px;
  line-height: 1;

  .product-number {
    color: #00c9ff;
    font-weight: bold;
    margin-bottom: 13px;
    font-size: 18px;
  }

  .location {
    color: #6c6c6c;
    font-weight: bold;
    margin-bottom: 17px;
    font-size: 16px;

    .fa-warehouse-alt {
      color: #343a40;;
    }
  }

}

.unloading-info-right {

  margin-top: 15px;
  line-height: 1;

  p {
    text-align: right;
    margin-top: 30px;
    color: #888888;
    font-size: 16px;

    .fa-clock {
      color: #00c9ff;
      margin-right: 4px;
    }
  }
}


</style>
